var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9334 15.8917C11.9334 16.4 11.6 17.0667 11.175 17.325L10.0001 18.0833C8.90838 18.7583 7.39171 18 7.39171 16.65V12.1917C7.39171 11.6 7.05838 10.8417 6.71672 10.425L3.51669 7.05833C3.09169 6.63333 2.75838 5.88334 2.75838 5.37501V3.44167C2.75838 2.43334 3.51673 1.67501 4.44173 1.67501H15.5584C16.4834 1.67501 17.2417 2.43333 17.2417 3.35833V5.20833C17.2417 5.88333 16.8167 6.72501 16.4 7.14167",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.3918 13.7667C14.8645 13.7667 16.0585 12.5728 16.0585 11.1C16.0585 9.62725 14.8645 8.43333 13.3918 8.43333C11.919 8.43333 10.7251 9.62725 10.7251 11.1C10.7251 12.5728 11.919 13.7667 13.3918 13.7667Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5584 14.2666L15.7251 13.4333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.cd37e1162abeed37af21f0d941ebd0b4.svg";
export { ForwardRef as ReactComponent };